import React, { Component } from 'react';
import CustomLoader from '../../common/Loader';
import { loadInfo } from '../../../services/formService';
import { getListValues } from '../../../services/listService';

class InfoViewer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Widget_ID: this.props.Widget_ID,
			Display_Name: '',
			Content: '',
			loading: true,
			FilterParametersList: this.props.FilterParametersList,
		};
	}

	async componentDidMount() {
		const { data } = await loadInfo(this.state.Widget_ID);

		if (typeof data === 'object') {
			this.setState({ Display_Name: data.Info.Display_Name });
			if ('Content' in data) {
				this.setState({ Content: data.Content });
			} else {
				this.setState({ Content: data.Info.ResultSource_Content });
			}
		}

		this.setState({ loading: false });
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.FilterParametersList.toString() !== this.props.FilterParametersList.toString()) {
			this.setState({ FilterParametersList: this.props.FilterParametersList }, () => {
				this.getListTypeParametersList();
			});
		}
		this.state.FilterParametersList.map((param) => {
			param['Name'] = param['Name'].replace('@', '')
			return param
		});
	}

	getListTypeParametersList = async () => {
		const { FilterParametersList: OldFilterParametersList } = this.state;
		const Type_List_Parameters_Promise_List = this.props.FilterParametersList.filter((obj) => {
			return obj.Type === 'list';
		}).map((obj) => {
			return getListValues(obj.List_ID);
		});

		const List_Type_Parameters_List = await (
			await Promise.all(Type_List_Parameters_Promise_List)
		)
			.map((obj) => obj.data)
			.map((listValues) => {
				const { List_ID } = listValues[0];
				return { List_ID, listValues };
			});

		const FilterParametersList = OldFilterParametersList.map((obj) => {
			const List_Type_Parameters = List_Type_Parameters_List.filter((listValues) => {
				return obj.List_ID === listValues.List_ID;
			})[0];
			return { ...obj, List_Type_Parameters: List_Type_Parameters?.listValues };
		});

		this.setState({ FilterParametersList });
	};

	handleFilterParameters = (ev) => {
		const { FilterParametersList: oldFilterParametersList } = this.state;
		const { name, value } = ev.target;
		const FilterParametersList = oldFilterParametersList.map((obj) => {
			if (obj.Name === name) {
				return { ...obj, Value: value };
			} else {
				return obj;
			}
		});

		this.setState({ FilterParametersList });
	};

	handleFilterParametersDropdown = (Parameter_ID, { target }) => {
		const { FilterParametersList: oldFilterParametersList } = this.state;

		const FilterParametersList = oldFilterParametersList.map((obj) => {
			if (obj.Parameter_ID === parseInt(Parameter_ID)) {
				return { ...obj, Value: target.value };
			} else {
				return obj;
			}
		});
		this.setState({ FilterParametersList });
	};

	handleFilterSearch = () => {
		this.props.onSubmitFilterParameters(this.state.FilterParametersList);
	};

	render() {
		const { FilterParametersList } = this.state;
		if (this.state.loading) {
			return <CustomLoader loading={this.state.loading} />;
		}
		return (
			<div className='card'>
				<div className='card-body'>
					{FilterParametersList &&
						FilterParametersList.map((obj) => (
							<>
								{obj.List_ID && obj.List_Type_Parameters && (
									<>
										<select id={obj.Parameter_ID} name={obj.Parameter_ID} value={JSON.stringify(obj.value)} className='btn' onChange={this.handleFilterParametersDropdown.bind(null, obj.Parameter_ID)}>
											<option value='0'>Select</option>
											{obj.List_Type_Parameters.map((vals) => (
												<option key={vals.id} value={vals.Value_Text}>
													{vals.Value_Text}
												</option>
											))}
										</select>
									</>
								)}
								{!obj.List_ID && <input key={obj.Parameter_ID} type={obj.Type} name={obj.Name} className='mr-1' value={obj.Value} onChange={this.handleFilterParameters} placeholder={obj.Name} />}
							</>
						))}

					<button className='btn btn-blue' onClick={this.handleFilterSearch}>
						Search
					</button>
				</div>
			</div>
		);
	}
}

export default InfoViewer;
